import { faker } from '@faker-js/faker';
import type {
  DeviceLogResourceReadApi,
  LogFileApi,
  PaginationApi,
} from '@ingenico/api-sdk-device-management-private-v2';
import {
  enumDeviceLogStatus,
  enumDeviceLogType,
  enumLogFileType,
} from '@ingenico/api-sdk-device-management-private-v2';
import { toNumber } from 'lodash-es';
import type { PathParams, HttpRequestResolverExtras, ResponseResolverInfo } from 'msw';
import { HttpResponse } from 'msw';

const count = 33;

function generatePaginationApi({
  total,
  offset,
  limit,
}: {
  readonly total: number;
  readonly offset: number;
  readonly limit: number;
}): PaginationApi {
  const initialTerm = Math.ceil(offset / total);
  return {
    totalResults: total,
    startIndex: initialTerm,
    itemsPerPage: limit,
  };
}

function getDeviceLogsTypes(): DeviceLogResourceReadApi['types'] {
  const values = Object.values(enumDeviceLogType);
  const countTypes = values.length > 0 ? faker.number.int({ min: 1, max: values.length }) : 0;
  return [...new Set(faker.helpers.multiple(() => faker.helpers.arrayElement(values), { count: countTypes }))];
}

function getDeviceLogFile(): LogFileApi {
  return {
    fileName: faker.system.fileName(),
    logFileId: faker.string.uuid(),
    size: faker.number.int({ min: 1000, max: 30_000 }),
    filetype: faker.helpers.arrayElement(Object.values(enumLogFileType)),
  };
}

function generateMockedDeviceLogResurce(): DeviceLogResourceReadApi {
  return {
    description: faker.lorem.sentence(),
    deviceLogId: faker.string.uuid(),
    endDate: faker.date.past(),
    startDate: faker.date.past(),
    title: faker.animal.horse(),
    requestedDuration: faker.number.int({ min: 60, max: 86_399 }),
    logFiles: faker.helpers.multiple(getDeviceLogFile, { count: faker.number.int({ min: 1, max: 3 }) }),
    types: getDeviceLogsTypes(),
    status: faker.helpers.arrayElement(Object.values(enumDeviceLogStatus)),
  };
}

export function searchDeviceLogV2CustomHandler(context: ResponseResolverInfo<HttpRequestResolverExtras<PathParams>>) {
  const url = new URL(context.request.url);

  const offset = toNumber(url.searchParams.get('offset') ?? 0);
  const limit = toNumber(url.searchParams.get('limit') ?? 10);

  const searchCount = faker.number.int({ min: 1, max: limit });

  return HttpResponse.json({
    data: faker.helpers.multiple(generateMockedDeviceLogResurce, { count: searchCount }),
    pagination: generatePaginationApi({ total: count * limit, offset, limit }),
  });
}
